/*
SaiKrishna 10/06/2022 2698403495 Removed unnecessary console.log statements
SaiKrishna 11/10/2022 3225733165 Fixed account nots to work queue redirection bugs
Ashraf 12/05/2022 3225733165 fixed client code issues
Ashraf 12/13/2022 3225733165 renamed special notes to Important Notes
Ashraf 12/16/2022  3225733165 fixed role access
Dilip 12/21/2022 3225733165 changed back to search label
Dilip 12/29/2022 3225733165 changed work queue list as route for back to list
Suresh Peddavoora 01/20/2023 3225733165 Added Table in Split Screen
dilip 01/26/2023 3225733165 Add lock account check functionality
dilip 01/31/2023 3225733165 Split work queue functionality
dilip 02/09/2023 3225733165 Fixed Account remove functionality issue from WQ.
Akhila 03/10/2023 3225733165 fixed page break-issue
Prakash 07/04/2023 3225733165 fixed sticky issue in account summary.
Prakash 1/05/2023 3225733165 fixed alignments issue work queuel list and account summary.
Suresh Peddavoora 06/13/2023 3225733165 Fixed sticky Tabs issue Alignments
Ravi 06/13/2023 3225733165 Fixed page break issue
suresh peddavoora 06/13/2023 2698811066 Added Classname for Mobile Responsive issues.
Prakash 15/06/2023 3225733165 add condition classname work queuel list and account summary.
*/
import React, { useContext, useState, useEffect, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router';
import LandingPage from '../LandingPage';
import SideCards from './SidePanel';
import { useDispatch, useSelector } from 'react-redux';
import PatientSummary from './PatientSummary/index';
import { ThemeContext } from '../../themes/ThemeProvider';
import { ErrorSnackbar, SuccessSnackbar } from '../../components/CustomSnackBar';
import SelectTabContextProvider from '../../components/SelectTabContext/SelectTabContext';
import { SPLIT_SCREEN } from '../../constants/WorkQueueConstants';
import { getLockedAccountInfo, resetAccountLockStatus } from '../../redux/reducers/AccountSummary';
import { Button, IconButton, Tooltip, makeStyles } from '@material-ui/core';
import { ArrowBack } from '@material-ui/icons';
import CustomTabsNew from './CustomTabs/index2';
import Paginate from './Paginate';
import {
  changeWorkQueueSession,
  getAccountExistsInfo,
  getWorkQueueListData,
} from '../../redux/reducers/WorkQueueList';
import MenuPopover from './MenuPopover';
import RefreshIcon from '@material-ui/icons/Refresh';
import PageLoader from '../../components/PageLoader';
import { IconComponent } from './IconComponent';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import NoResultsMessage from '../EmptyResultsWindow/EmptyWindowMessage';
import { ReactComponent as NoAccountSelectedIcon } from '../../assets/images/noAccountSelectedIcon.svg';
import { SaveWindowDataProvider } from '../../contexts/SaveWindowDataContext.js';
import { FormUpdatedProvider } from '../../contexts/FormUpdatedContext.js';
import { ResetWindowDataProvider } from '../../contexts/ResetWindowDataContext.js';

const handleChangeOrder = (pv, title) => {
  if (pv?.orderBy === title) {
    if (pv.orderDirection === 'asc') {
      return 'desc';
    } else if (pv.orderDirection === 'desc') {
      return '';
    } else {
      return 'asc';
    }
  } else {
    return 'asc';
  }
};
const useStyles = makeStyles((theme) => ({
  dashboard: {
    padding: 0,
    marginBottom: 15,
    color: '#ffffff',
  },
}));
export default function DetailedView() {
  const classes = useStyles();
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  const [selected, setSelected] = useState([]);
  const [age, setAge] = useState(false);
  const { hideSummary } = useContext(SelectTabContextProvider);
  const { toggleWorkqueue, setToggleWorkqueue } = useContext(SelectTabContextProvider);
  const { sideNavSection, showWidgetSection } = useContext(ThemeContext);
  const { successMsg, errorMsg } = useSelector(({ favouriteWindows }) => favouriteWindows);
  const { showDashboardWorkQueue } = useSelector(({ role }) => role);
  const { workQueueListData, isLoading } = useSelector(({ workQueueList }) => workQueueList);
  const [accountNo, setAccountNo] = useState('');

  const { lockedByUser, accountLockedStatus, accountLocked } = useSelector(
    ({ accountSummary }) => accountSummary,
  );

  const [columns, setColumns] = useState({
    ACCOUNT_NUMBER: {
      field: 'account_number',
      title: 'ACCOUNT_NUMBER',
      sortFieldObj: 'debtor_account.ACCOUNT_NUMBER',
    },
  });

  const columnsData = useMemo(() => {
    const columnsArr = [];
    if (workQueueListData) {
      const sortFields = workQueueListData?.sortFields || [];
      const fieldHeaders = workQueueListData?.fieldHeaders || [];
      const sortFieldObj = {};
      sortFields.forEach((item) => {
        sortFieldObj[item.sortingField] = item.orderBy;
      });
      if (fieldHeaders?.length > 0) {
        fieldHeaders.forEach(({ fieldHeader, fieldName }, i) => {
          if (fieldName !== 'IS_LOCKED') {
            columnsArr.push({
              field: fieldName?.toLowerCase(),
              title: fieldHeader,
              sortFieldObj: sortFieldObj[fieldHeader] || '',
              order: i + 1,
            });
          }
        });
      }

      const obj = {};
      columnsArr.forEach((col) => {
        obj[col.title] = col;
      });
      setColumns(obj);
    }
    return columnsArr;
  }, [workQueueListData]);

  const BatchName = history?.location?.state?.BatchName;
  const { roleData } = useSelector(({ role }) => role);
  const accountNumber = location?.state?.accountNumber ? location.state.accountNumber : '';
  const accNo = location?.state?.accNo ? location?.state?.accNo : '';

  const getWorkQueueListDataFn = (payload) => {
    dispatch(getWorkQueueListData(payload));
  };

  const getWorkQueueData = () => {
    if (showDashboardWorkQueue === SPLIT_SCREEN.SHOW_SPLIT_SCREEN) {
      const { workQueueNextAccount } = changeWorkQueueSession();
      if (workQueueNextAccount?.payload) {
        getWorkQueueListDataFn(workQueueNextAccount?.payload);
      }
    }
  };

  useEffect(() => {
    return () => {
      setToggleWorkqueue(false);
    };
  }, []);

  useEffect(() => {
    if (location.pathname === '/account-summary' && location?.state?.accountNumber && !accNo) {
      dispatch(getLockedAccountInfo(location?.state?.accountNumber));
    }
  }, [location?.state?.accountNumber]);

  useEffect(() => {
    if (accountLockedStatus && !accNo) {
      localStorage.setItem('AccountNumber', '');
      history.push({
        pathname: location?.pathname,
        state: {
          accountNumber: '',
          batchName: '',
          accountData: [],
        },
      });
    }
    setTimeout(() => {
      dispatch(resetAccountLockStatus());
    }, 10000);
  }, [accountLockedStatus, lockedByUser]);

  useEffect(() => {
    if (accNo && !accountNumber) {
      const { workQueueNextAccount } = changeWorkQueueSession();
      dispatch(
        getAccountExistsInfo({
          accountNumber: accNo,
          workQueueId: workQueueNextAccount?.workQueueRowData?.workqueueId || 0,
        }),
      );
    }
  }, [accNo]);

  useEffect(() => {
    if (accountNumber) {
      if (SPLIT_SCREEN.SHOW_SPLIT_SCREEN === showDashboardWorkQueue) {
        getWorkQueueData();
      }
      history.push({
        pathname: '/account-summary',
        state: {
          accountNumber: accountNumber ? accountNumber : '',
          fromWorkQueue: location?.state?.fromWorkQueue ? location.state.fromWorkQueue : '',
          BatchName: location?.state?.BatchName ? location.state.BatchName : '',
          accountData: location?.state?.accountData ? location?.state?.accountData : [],
          fromAccountList: location?.state?.fromAccountList ? location?.state?.fromAccountList : '',
          clientCode: location?.state?.clientCode ? location.state.clientCode : '',
        },
      });
    }
  }, [roleData, accountNumber]);

  // TODO: add this to a configuration file
  const [tabs, setTabs] = useState([
    { label: 'Pending Transactions (W33)', deleteIcon: true },
    { label: 'Imaging (W47)', deleteIcon: true },
    { label: 'Letter History (W52)', deleteIcon: true },
    { label: 'Health Insurance Info (W703)', deleteIcon: true },
    { label: 'Collectors Script (W705)', deleteIcon: true },
    { label: 'Skip Tools (W557)', deleteIcon: true },
    { label: 'Important Notes', deleteIcon: true },
    { label: 'Payments', deleteIcon: true },
    { label: 'Notes', deleteIcon: true },
    { label: 'Account Multiples', deleteIcon: true },
    { label: 'Tie Parameters (W51)', deleteIcon: true },
  ]);

  useEffect(() => {
    setAccountNo(accountNumber);
    if (accountNumber) {
      localStorage.setItem('accountNumber', accountNumber);
    }
  }, [accountNumber]);

  useEffect(() => {
    if (!accountNo && localStorage.getItem('accountNumber')) {
      setAccountNo(localStorage.getItem('accountNumber'));
    }
  }, [accountNo]);

  return (
    <LandingPage tabs={tabs} setTabs={setTabs} selected={selected} setSelected={setSelected}>
      {BatchName && history?.location?.state?.fromAccountList === '/batch-account-list' ? (
        <Button
          className={`${classes.dashboard}`}
          variant="text"
          onClick={() => {
            history.push({
              pathname: '/batch-account-list',
              state: {
                accountNumber: '',
                BatchName: BatchName,
              },
            });
          }}
        >
          <ArrowBack className="mr-2" />
          Back to Batch List
        </Button>
      ) : (
        ''
      )}
      {accountNumber ? (
        <>
          <div
            className={
              location.pathname === `/account-summary` && location?.state?.batchName
                ? `fixed-header-account`
                : showDashboardWorkQueue && location.pathname === `/account-summary`
                  ? `fixed-header-split-account`
                  : ``
            }
          >
            {toggleWorkqueue}
            {toggleWorkqueue &&
              showDashboardWorkQueue === SPLIT_SCREEN.SHOW_SPLIT_SCREEN &&
              workQueueListData?.resultObject?.length > 0 && (
              <div className={sideNavSection ? 'split-block' : 'split-container'}>
                <div className="accounts-section">
                  <div className="d-flex justify-content-between">
                    <MenuPopover
                      columnsData={columnsData}
                      columns={columns}
                      setColumns={setColumns}
                    />
                    <Tooltip title="Refresh">
                      <IconButton
                        aria-label="close"
                        className={classes.closeButton}
                        onClick={() => {
                          getWorkQueueData();
                        }}
                      >
                        <RefreshIcon />
                      </IconButton>
                    </Tooltip>
                  </div>
                  <div className="widget-section">
                    <div className="split-container-table">
                      <table className="split-screen-table">
                        <thead>
                          {Object.values(columns)?.map((item, i) => {
                            return (
                              <th
                                key={i}
                                onClick={() => {
                                  const { workQueueNextAccount, updateSession } =
                                      changeWorkQueueSession();
                                  const name = item.sortFieldObj;
                                  const newOrderDirection = handleChangeOrder(
                                    workQueueNextAccount?.payload,
                                    name,
                                  );
                                  const newOrders = {
                                    orderBy: newOrderDirection
                                      ? name.toLowerCase().replaceAll(' ', '_')
                                      : '',
                                    orderDirection: newOrderDirection,
                                  };
                                  const payload = {
                                    ...workQueueNextAccount?.payload,
                                    ...newOrders,
                                  };
                                  updateSession({
                                    ...workQueueNextAccount,
                                    payload,
                                    [showDashboardWorkQueue]: {
                                      ...workQueueNextAccount[showDashboardWorkQueue],
                                      ...newOrders,
                                    },
                                  });
                                  getWorkQueueListDataFn(payload);
                                }}
                              >
                                {item?.title}
                                <IconComponent field={item?.field} />
                              </th>
                            );
                          })}
                        </thead>
                        {workQueueListData?.resultObject &&
                            workQueueListData?.resultObject.map((ele, index) => {
                              const isLocked = ele['IS_LOCKED'] === 'Y';
                              const isAccountActive =
                                location.state?.accountNumber == ele.account_number;
                              if (!isLocked) {
                                return (
                                  <tr
                                    key={index}
                                    style={{
                                      cursor: isAccountActive ? 'default' : 'pointer',
                                      color: isAccountActive ? 'White' : '',
                                      background: isAccountActive ? '#056c93' : '',
                                    }}
                                    onClick={() => {
                                      if (!isAccountActive) {
                                        history.push({
                                          pathname: `/account-summary`,
                                          state: {
                                            accNo: ele['account_number'],
                                            currentAccNo: accountNumber,
                                          },
                                        });
                                      }
                                    }}
                                  >
                                    {Object.values(columns)?.map((item, i) => {
                                      let eleKey = item?.field;
                                      if (typeof ele[eleKey] === 'undefined') {
                                        eleKey = item?.title;
                                      }

                                      return <td key={i}>{ele[eleKey]}</td>;
                                    })}
                                  </tr>
                                );
                              }
                              return (
                                <tr
                                  key={index}
                                  style={{
                                    cursor: 'default',
                                    color: '#fff',
                                    background: '#df8b8b',
                                  }}
                                >
                                  {Object.values(columns)?.map((item, i) => {
                                    let eleKey = item?.field;
                                    if (typeof ele[eleKey] === 'undefined') {
                                      eleKey = item?.title;
                                    }
                                    return (
                                      <td key={i}>
                                        {ele[eleKey]}
                                        {i === 0 && <LockOutlinedIcon className="locked-icon" />}
                                      </td>
                                    );
                                  })}
                                </tr>
                              );
                            })}
                      </table>
                    </div>
                    <Paginate
                      workQueueListData={workQueueListData}
                      getWorkQueueListDataFn={getWorkQueueListDataFn}
                    />
                    {isLoading && <PageLoader />}
                  </div>
                </div>
              </div>
            )}
            <div
              className={
                showWidgetSection
                  ? 'dashboard-content'
                  : sideNavSection
                    ? 'dashboard-summary'
                    : toggleWorkqueue &&
                    showDashboardWorkQueue === SPLIT_SCREEN.SHOW_SPLIT_SCREEN &&
                    workQueueListData?.resultObject?.length > 0
                      ? 'dashboard-content-collapse dashboard-split-collapse'
                      : 'dashboard-content-collapse'
              }
            >
              <div id="third" className="patient-summary-card">
                <PatientSummary
                  accountNo={accountNo}
                  age={age}
                  setAge={setAge}
                  hideSummary={hideSummary}
                />
              </div>
              <SaveWindowDataProvider>
                <ResetWindowDataProvider>
                  <FormUpdatedProvider>
                    <CustomTabsNew
                      selected={selected}
                      setSelected={setSelected}
                      age={age}
                      setAge={setAge}
                    />
                  </FormUpdatedProvider>
                </ResetWindowDataProvider>
              </SaveWindowDataProvider>
            </div>
          </div>
          <div
            className={
              showWidgetSection
                ? location.pathname === `/account-summary` && location?.state?.batchName
                  ? ` sidecards-content sidecards-content-account`
                  : `sidecards-content ${showDashboardWorkQueue ? `split-sideCards-content` : ''}`
                : 'sidecards-content-collapse d-none'
            }
          >
            <SideCards />
          </div>
          {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
          {successMsg && <SuccessSnackbar successMsg={successMsg} />}
          {accountLockedStatus && (
            <ErrorSnackbar
              errorMsg={`Account ${accountLocked} has been locked by ${lockedByUser}, please try again later.`}
            />
          )}
        </>
      ) : (
        <NoResultsMessage
          title="No account selected"
          description="Get started by searching and selecting an account to view. A few ways to search for an account is by First or Last Name, Account Number or even SSN."
          icon={NoAccountSelectedIcon}
        />
      )}
    </LandingPage>
  );
}
